var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	94120: {
		fallback: () => (__webpack_require__.e(967).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	57278: {
		fallback: () => (__webpack_require__.e(967).then(() => (() => (__webpack_require__(8143))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	64733: {
		fallback: () => (__webpack_require__.e(967).then(() => (() => (__webpack_require__(36612))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.11.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router",

	},
	3374: {
		fallback: () => (Promise.all([__webpack_require__.e(239), __webpack_require__.e(96), __webpack_require__.e(278)]).then(() => (() => (__webpack_require__(48527))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.4.5",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "antd",

	},
	66254: {
		fallback: () => (Promise.all([__webpack_require__.e(967), __webpack_require__.e(96), __webpack_require__.e(278), __webpack_require__.e(733)]).then(() => (() => (__webpack_require__(95980))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^6.11.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-router-dom",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"69": [
		66254
	],
	"120": [
		94120
	],
	"278": [
		57278
	],
	"374": [
		3374
	],
	"733": [
		64733
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}